// Video2026 block: click the poster's play button to swap in the real player
// (an autoplay iframe for an embed URL, or a native <video> for an uploaded file).
(function () {
    function buildPlayer(frame) {
        var embed = frame.getAttribute('data-embed');
        var file = frame.getAttribute('data-file');
        var el = null;

        if (embed) {
            el = document.createElement('iframe');
            el.src = embed;
            el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            el.setAttribute('allowfullscreen', '');
            el.setAttribute('frameborder', '0');
        } else if (file) {
            el = document.createElement('video');
            el.src = file;
            el.controls = true;
            el.autoplay = true;
            el.setAttribute('playsinline', '');
        }

        if (el) {
            el.className = 'video2026__player';
            frame.innerHTML = '';
            frame.appendChild(el);
        }
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.video2026__play') : null;
        if (!btn) {
            return;
        }
        var frame = btn.closest('[data-video2026]');
        if (frame) {
            buildPlayer(frame);
        }
    });
})();
